module.exports = "/images/wifi.jpg?27d25be8b41c82a0a739bb83c8856144";